import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { Accordion, AccordionTab } from "primereact/accordion";
import { confirmDialog } from "primereact/confirmdialog";
//components
import NumberInput from "../../../../components/input/NumberInput";
import Switch from "../../../../components/input/Switch";
//services
import { postDiscount } from "../../../../services/Settings/Simulator/postDiscount";
import { deleteDiscount } from "../../../../services/Settings/Simulator/deleteDiscount";
import { postDiscountTerm } from "../../../../services/Settings/Simulator/postDiscountTerm";

export default function Discounts({ setActiveIndex, info, loading, refetch }) {
  const { id } = useParams();
  // const [show, setShow] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [checked, setChecked] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);

  const form = useForm();
  const errors = form.formState.errors;
  const formForward = useForm();
  const errorsForward = formForward.formState.errors;

  const columns = [
    { field: "percentage", header: "Desconto em %" },
    { field: "max_installments", header: "Máximo Parcelas" },
  ];

  const onSubmitForward = async (data) => {
    if (data.term_discount_max === null) {
      data.term_discount_max = 0;
    }
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    data.enterprise_id = id;
    const response = await postDiscountTerm(data);
    if (response.success) {
      refetch().then(() => {
        toast.update(notification, {
          render: "Desconto cadastrado com sucesso",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
        setLoadingButton(false);
      });
    } else {
      toast.update(notification, {
        render: response.error,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
    }
  };

  const onSubmit = async (data) => {
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    data.enterprise_id = id;
    const response = await postDiscount(data);
    if (response.success) {
      refetch().then(() => {
        toast.update(notification, {
          render: "Desconto cadastrado com sucesso",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
        setLoadingButton(false);
      });
    } else {
      toast.update(notification, {
        render: response.error,
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
    }
    form.reset();
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const removeOption = (e, rowData) => {
    const discountDelete = async (id) => {
      const notification = toast.loading("Por favor aguarde...");
      const response = await deleteDiscount(id);
      if (response.success) {
        refetch().then(() => {
          toast.update(notification, {
            render: "Desconto deletado com sucesso",
            autoClose: 1000,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        });
      } else {
        toast.update(notification, {
          render: "Ocorreu algum erro!",
          autoClose: 1000,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      }
    };

    e.preventDefault();
    confirmDialog({
      message: "Você deseja deletar esse desconto?",
      header: "Confirmação",
      icon: "fa-solid fa-ban",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => discountDelete(rowData.id),
    });
  };

  useEffect(() => {
    if (info) {
      const infoPercentage = info.discounts_in_cash.map((item) => {
        if (item && item.percentage != null) {
          return { ...item, percentage: `${item.percentage}%` };
        }
        return item;
      });
      setTableData(infoPercentage);
      const defaultValues = {
        enable_term_discount: info.enable_term_discount === 1,
        max_term_discount: info.max_term_discount,
      };
      setChecked(info.enable_term_discount === 1);
      formForward.reset(defaultValues);
    }
  }, [info, loading, formForward]);

  return (
    <>
      {loading ? (
        <>
          <div className="d-flex">
            <Skeleton width="100%" height="300px" />
          </div>
          <div className="row mt-4">
            <div className="col-md-6 d-flex justify-content-start">
              <Skeleton width="20%" height="50px" />
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <Skeleton width="20%" height="50px" />
            </div>
          </div>
        </>
      ) : (
        <>
          <Accordion activeIndex={0}>
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-comment-dollar"></i>
                  <span className="mx-2 vertical-align-middle">
                    Desconto a Vista
                  </span>
                </div>
              }
            >
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <div className="row justify-content-between">
                  <div className="col-xl-5">
                    <NumberInput
                      name="percentage"
                      suffix="%"
                      placeholder="0%"
                      required={true}
                      max={100}
                      minFractionDigits={2}
                      maxFractionDigits={2}
                      tooltipOptions={{ position: "top" }}
                      label="Desconto de venda à vista"
                      tooltip="Quando o cliente realiza uma compra à vista, é neste campo que se configura a taxa de desconto"
                      control={form.control}
                      errors={errors}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-xl-5">
                    <NumberInput
                      name="max_installments"
                      max={10000}
                      required={true}
                      placeholder="0"
                      tooltipOptions={{ position: "top" }}
                      label="Número Máximo de Parcelas à Vista"
                      tooltip="Digite o número máximo de seu parcelamento para vendas á vista para o respectivo desconto."
                      control={form.control}
                      errors={errors}
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-xl-2">
                    <Button
                      rounded
                      type="submit"
                      iconPos="right"
                      label="Adicionar"
                      icon="fa-solid fa-plus"
                      loading={loadingButton}
                      className="p-inputtext-sm ms-3 mt-4"
                    />
                  </div>
                </div>
              </form>
              <div className="row">
                <>
                  <hr className="my-4" />
                  <div className="px-2 pb-3">
                    <DataTable
                      rows={5}
                      paginator
                      stripedRows
                      showGridlines
                      sortMode="multiple"
                      selectionMode="single"
                      rowsPerPageOptions={[5, 25, 100]}
                      value={tableData}
                      totalRecords={tableData.length}
                      emptyMessage="Nenhuma Informação foi encontrada."
                      tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                    >
                      {columns.map((col) => (
                        <Column
                          sortable
                          key={col.field}
                          field={col.field}
                          header={col.header}
                        />
                      ))}
                      <Column
                        header="Ações"
                        body={(rowData) => (
                          <div className="text-center">
                            <button
                              className="btn btn-danger btn-btn-sm"
                              onClick={(e) => removeOption(e, rowData)}
                            >
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          </div>
                        )}
                      />
                    </DataTable>
                  </div>
                </>
              </div>
            </AccordionTab>
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-receipt"></i>
                  <span className="mx-2 vertical-align-middle">
                    Desconto a Prazo
                  </span>
                </div>
              }
            >
              <form onSubmit={formForward.handleSubmit(onSubmitForward)}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="pb-4">
                      <b>Habilitar Desconto à Prazo </b>
                      <Tooltip target=".custom-target-icon" />
                      <i
                        className="custom-target-icon pi pi-info-circle p-text-secondary"
                        data-pr-tooltip="Quando o cliente realiza uma compra à vista, é neste campo que se configura a taxa de desconto"
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>

                    <div className="d-flex mt-4">
                      <Switch
                        name="enable_term_discount"
                        control={formForward.control}
                        checked={checked}
                        getFormErrorMessage={getFormErrorMessage}
                      />
                      <div className="mx-2">
                        <Tooltip target=".custom-target-icon" />
                        <i
                          className="custom-target-icon pi pi-info-circle p-text-secondary"
                          data-pr-tooltip="Caso esta opção esteja habilitada, será exibido um campo para flexibilizar o desconto durante uma venda à prazo"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="pb-4">
                      <b> Informe o máximo de desconto a prazo </b>
                      <Tooltip target=".custom-target-icon" />
                      <i
                        className="custom-target-icon pi pi-info-circle p-text-secondary"
                        data-pr-tooltip="Digite o número máximo de seu parcelamento para vendas á vista. Caso esteja configurado algum desconto, ele será aplicado no parcelamento de acordo com o número de parcelas máximas correspondentes aquele desconto"
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>
                    <NumberInput
                      name="max_term_discount"
                      suffix="%"
                      placeholder="0%"
                      max={100}
                      minFractionDigits={2}
                      control={formForward.control}
                      errors={errorsForward}
                      label="Máximo de desconto"
                      getFormErrorMessage={getFormErrorMessage}
                    />
                  </div>
                  <div className="col-md-2 pt-4">
                    <Button
                      rounded
                      type="submit"
                      iconPos="right"
                      label="Salvar"
                      loading={loadingButton}
                      icon="fa-solid fa-check"
                      className="p-inputtext-sm ms-3 mt-5"
                    />
                  </div>
                </div>
              </form>
            </AccordionTab>
          </Accordion>
        </>
      )}
    </>
  );
}
